import React from 'react';
import OptionGroup from './OptionGroup';

const renderOptions = (options, initialSelection) =>
  options.map((option, index) => {
    const isStringOption = typeof option === 'string';
    if (!isStringOption && option.optgroup) {
      return <OptionGroup {...option.optgroup} />
    }

    if (!isStringOption && option.renderer) {
      return option.renderer(option);
    }

    const optionValue = isStringOption ? option : option.value || option.text;
    return (
      <option
        key={optionValue}
        value={optionValue}
        selected={initialSelection === option.value}
      >
        {isStringOption ? option : option.text}
      </option>
    );
  });

export default renderOptions;
